<template>
  <div class="poster">
    <div v-infinite-scroll="loadMore"
      :infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
      style="flex: 1;overflow-y: auto;">
        <img v-for="(item, key) in list" :key="key" :src="item.icon">
    </div>
    <div v-if="block.redirect" class="foot"><button @click="clickHandle">查&nbsp;看&nbsp;课&nbsp;程</button></div>
  </div>
</template>
<script>
import { InfiniteScroll } from 'mint-ui'
import { moreInfo } from '@/api/more'
import { setTitle } from '@/api/app'
import { umtrack } from '@/utils/uweb'
import { openWindow } from '@/api/app'
export default {
  name: 'poster',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    InfiniteScroll
  },
  props: {
    options: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  created () {
    var query = this.$route.query
    this.id = query.id
    umtrack('posterView', {id: this.id, title: this.title}, this)
  },
  data () {
    return {
      id: 0,
      loading: true,
      pageinfo: {
        current_page: 0
      },
      list: [],
      block: {}
    }
  },
  methods: {
    loadMore: function () {
      if(this.pageinfo.current_page > 0 && this.pageinfo.current_page == this.pageinfo.last_page){
        return
      }
      this.loading = true;
      moreInfo({id: this.id, page: (this.pageinfo.current_page + 1)}).then(response => {
        var data = response.data.data
        if(!this.template){
            this.block = data.blockInfo
            setTitle(this.block.title)
        }
        this.pageinfo = {
          current_page: data.current_page,
          last_page: data.last_page
        }
        this.list = this.list.concat(data.data)
        this.loading = false;
      })
    },
    routerback: function () {
      this.$router.back(-1)
    },
    clickHandle: function () {
      if (this.block.urltype == 0) {
        openWindow(1, this.block.redirect, '', this)
      } else {
        openWindow(0, this.block.redirect, '', this)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.poster {
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  font-size: 0;
}
.poster img{
  width: 100%;
  display: inline-block;
}
.poster .foot{
    padding: 16px;
    position:fixed;
    bottom: 0;
    left: 0;
    width: calc(100% - 32px) ;
}
.poster .foot button{
    border: none;
    width: 100%;
    border-radius: 10px;
    padding: 14px 0;
    text-align: center;
    color: #fff;
    font-size: 18px;
    background-color: rgb(250, 93, 20);
}
</style>
